import angular from 'angular'
import moment from 'moment-timezone'

angular
  .module('admin.default_bounty_shinies.edit', [])
  .controller('DefaultBountyShiniesEditCtrl', DefaultBountyShiniesEditCtrl)

/** @ngInject */
function DefaultBountyShiniesEditCtrl(
  $scope,
  $state,
  $timeout,
  $stateParams,
  $rootScope,
  DefaultBountyShiniesService,
  EventService,
  UploadService,
) {
  var vm = this

  vm.model = {}
  vm.pathImgThumb = ''
  vm.pathImgLarge = ''
  vm.pathImgLargeBack = ''
  vm.id = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false
  vm.channels = []

  vm.renderTypes = [
    { id: 0, t: 'Basic' },
    { id: 1, t: 'White' },
    { id: 2, t: 'Red' },
    { id: 3, t: 'Gold' },
    { id: 4, t: 'Purple' },
    { id: 5, t: 'Metal' },
  ]

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  EventService.listChannels().then(function (result) {
    vm.channels = result.results
  })

  function load() {
    if (vm.id !== '0') {
      DefaultBountyShiniesService.get(vm.id).then(function (result) {
        vm.model = result.results
        vm.filesObj = vm.model.obj
        if (vm.model['ts-start']) {
          vm.model['ts-start'] = vm.model['ts-start'] / 1000
          vm.model['ts-start'] = new Date(parseInt(vm.model['ts-start']))
          vm.data1 = angular.copy(vm.model['ts-start'])
        }

        if (vm.model['ts-end']) {
          vm.model['ts-end'] = vm.model['ts-end'] / 1000
          vm.model['ts-end'] = new Date(parseInt(vm.model['ts-end']))
          vm.data2 = angular.copy(vm.model['ts-end'])
        }
      })
    }
  }

  load()

  vm.save = function () {
    var model = angular.copy(vm.model)
    var isUpdate = model.id !== undefined && model.id !== '' && model.id !== 0
    delete model.ts

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-start'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-end'] = null
    }

    if (isUpdate) {
      DefaultBountyShiniesService.update(model.id, model).then(
        function (result) {
          $state.go('admin.default_bounty_shinies')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    } else {
      DefaultBountyShiniesService.create(model).then(
        function (result) {
          $state.go('admin.default_bounty_shinies')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.default_bounty_shinies')
  }

  vm.uploadThumb = function (item) {
    if (vm.pathImgThumb.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadThumb = true
    UploadService.save('collectibles', vm.pathImgThumb, 'img-t', item.id).then(function (fileName) {
      vm.loadThumb = false
      item['img-t'] = fileName
    })
  }

  vm.uploadLarge = function (item) {
    if (vm.pathImgLarge.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadLarge = true
    UploadService.save('collectibles', vm.pathImgLarge, 'img-l', item.id).then(function (fileName) {
      vm.loadLarge = false
      item['img-l'] = fileName
    })
  }

  vm.uploadLargeBack = function (item) {
    if (vm.pathImgLargeBack.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadLargeBack = true
    UploadService.save('collectibles', vm.pathImgLargeBack, 'img-b-l', item.id).then(function (fileName) {
      vm.loadLargeBack = false
      item['img-b-l'] = fileName
    })
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  vm.loadingObj = false
  vm.newUploadObj = false
  var watch3 = $scope.$watch('vm.objFile', function (newVal, oldVal) {
    if (!newVal) {
      vm.loadingObj = false
      return
    }
    if (newVal === oldVal) {
      vm.loadingObj = false
      return
    }

    var id = Math.random().toString(16).slice(2)
    if (vm.model.id) {
      id = vm.model.id
      vm.model.id = parseInt(vm.model.id)
    }

    vm.loadingObj = true
    UploadService.save('collectibles', newVal, 'obj-data', id).then(function (fileName) {
      vm.filesObj = fileName
      vm.model.obj = fileName
      vm.loadingObj = false
      vm.newUploadObj = true
      vm.glbProgress = 0
      toastr.success('Upload complete!')
    })
  })

  vm.glbProgress = 0
  $rootScope.$on('uploadProgress', function (event, data) {
    vm.glbProgress = data
    $scope.$apply()
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
    watch3()
  })

  vm.openCalendar1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen1 = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }
}
